import { styled } from '@mui/system';
import { CustomTextField } from 'components/common';
import { Control } from 'react-hook-form';
import { OnePagerFormFields } from './OnePagerForm';
import { CustomTextFieldAmount } from 'components/common';

const StyledTable = styled('table')({
  minWidth: 800,
  borderCollapse: 'collapse',
  width: '100%',
  '& td': {
    border: '1px solid #DFDFDF',
    width: 144,
  },
  '& tr': {
    '&:first-child': {
      '& td:first-child': {
        fontSize: 12,
      },
    },
    '& td:first-child': {
      textAlign: 'center',
    },
  },
});

interface ProjectionsTableProps {
  control: Control<OnePagerFormFields, object>;
}

const StyledCell = styled('td')({
  padding: '4px 10px 0 10px',
});

const YearInputComponent = ({
  name,
  control,
  placeholder,
}: {
  name: keyof OnePagerFormFields;
  control: Control<OnePagerFormFields, object>;
  placeholder: string;
}) => (
  <CustomTextField
    sx={{ position: 'relative', top: 3 }}
    control={control}
    name={name}
    placeholder={placeholder}
    fullWidth
    variant="standard"
    inputProps={{ maxLength: 4 }}
    size="small"
    // textAlign="right"
    // inputProps={{ style: { textAlign } }}
  />
);

const AmountInputComponent = ({
  name,
  control,
  currency,
}: {
  name: keyof OnePagerFormFields;
  control: Control<OnePagerFormFields, object>;
  currency: 'usd' | 'inr';
}) => (
  <CustomTextFieldAmount
    control={control}
    placeholder="Amount"
    name={name}
    currency={currency}
    // textAlign="right"
    variant="standard"
  />
);

export const ProjectionsTable = ({
  control,
  currency,
}: ProjectionsTableProps & { currency: 'usd' | 'inr' }) => {
  return (
    <StyledTable cellSpacing={0} cellPadding={0}>
      <tr>
        <td>(Amount in crores)</td>
        <StyledCell>
          <YearInputComponent
            name="yearOne"
            placeholder="Year 1"
            control={control}
          />
        </StyledCell>
        <StyledCell>
          <YearInputComponent
            name="yearTwo"
            placeholder="Year 2"
            control={control}
          />
        </StyledCell>
        <StyledCell>
          <YearInputComponent
            name="yearThree"
            placeholder="Year 3"
            control={control}
          />
        </StyledCell>
        <StyledCell>
          <YearInputComponent
            name="yearFour"
            placeholder="Year 4"
            control={control}
          />
        </StyledCell>
        <StyledCell>
          <YearInputComponent
            name="yearFive"
            placeholder="Year 5"
            control={control}
          />
        </StyledCell>
      </tr>
      <tr>
        <td>Revenue</td>
        <StyledCell>
          <AmountInputComponent
            name="revenueAmountOne"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="revenueAmountTwo"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="revenueAmountThree"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="revenueAmountFour"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="revenueAmountFive"
            control={control}
            currency={currency}
          />
        </StyledCell>
      </tr>
      <tr>
        <td>Expenses</td>
        <StyledCell>
          <AmountInputComponent
            name="expensesAmountOne"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="expensesAmountTwo"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="expensesAmountThree"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="expensesAmountFour"
            control={control}
            currency={currency}
          />
        </StyledCell>
        <StyledCell>
          <AmountInputComponent
            name="expensesAmountFive"
            control={control}
            currency={currency}
          />
        </StyledCell>
      </tr>
    </StyledTable>
  );
};
